import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import SwalServices from '../../services/swalServices/SwalServices';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import { Navigate } from "react-router-dom";
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { ProgressSpinner } from 'primereact/progressspinner';
import moment from 'moment';
import { getAuthProps } from '../../utils/AuthenticationLibrary';
import { WebToken } from '../../utils/AppSetting';
import { APIURL, DownloadCV, GetDynamicFormPreview, GetSubmittedFormPreview, GetUploadedFiles, PreviewCV } from '../../services/axiosServices/ApiEndPoints';
import { createRef } from 'react';

export default class TimesheetExpense extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.dt = createRef();
        this.loadingFilePaths = new Set();
        this.state = {
            submittedFormsList: [],
            downloadingIds: [],
            route: null,
            isLoading: false,
            dateRange: null,
            totalRecords: 0,
            searchTimeout: null,
            dateTimeout: null,
            isMergingPdf: false,
            showFilesDialog: false,
            isFilesLoading: false,
            uploadedFiles: [],
            filesDialogTitle: '',
            currentFileIndex: 0,
            fileBlobUrls: {}, // file.path -> object URL (or 'error')
            filterDetails: {
                start: 0,
                length: 50,
                search: '',
                formId: '',
                sortField: '',
                sortOrder: 'asc',
                startDate: '',
                endDate: '',
                formType: 'timesheet_expense',
                timesheetExpense: 1, // 1-timesheet, 2-expense
                isFormApproved: 0, // 1-Approved, 2-Not Approved
            }
        };
        this.exportCSV = this.exportCSV.bind(this);
        this.exportPdf = this.exportPdf.bind(this);
        this.exportExcel = this.exportExcel.bind(this);
        this.saveAsExcelFile = this.saveAsExcelFile.bind(this);

    }

    componentDidMount() {
        this.submittedForms();
    }

    componentWillUnmount() {
        // Clear the timeout when component unmounts to prevent memory leaks
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }
        if (this.state.dateTimeout) {
            clearTimeout(this.state.dateTimeout);
        }
        this.revokeFileBlobUrls();
        document.removeEventListener('keydown', this.handleViewerKeyDown);
    }

    submittedForms = () => {
        let filterDetials = this.state.filterDetails;
        this.setState({ isLoading: true })
        let request = [filterDetials.start,
        filterDetials.length,
        filterDetials.search,
        filterDetials.formId,
        filterDetials.sortField,
        filterDetials.sortOrder,
        filterDetials.startDate ? moment(filterDetials.startDate).format('YYYY-MM-DD HH:mm:ss') : '',
        filterDetials.endDate ? moment(filterDetials.endDate).format('YYYY-MM-DD HH:mm:ss') : '',
        filterDetials.formType,
        filterDetials.timesheetExpense,
        filterDetials.isFormApproved
        ];
        this.adminServices.submittedForms(request).then((response) => {
            if (response && response.data && response !== null) {
                let res = response.data?.data || [];
                const total = response.data?.totalRecords || 0;

                res.map((x, index) => {
                    x.srNo = index + 1
                })

                this.setState({
                    submittedFormsList: res,
                    totalRecords: total,
                    isLoading: false
                });
            }
        });

    }

    handleSearch = (value) => {
        // Clear the previous timeout if it exists
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }

        // Update the search value immediately in state for UI responsiveness
        let details = this.state.filterDetails;
        details.search = value;
        this.setState({ filterDetails: details });

        // Set a new timeout to call the API after 2 seconds of no typing
        const timeout = setTimeout(() => {
            this.submittedForms();
        }, 1500);

        // Store the timeout ID in state
        this.setState({ searchTimeout: timeout });
    }

    handleChangeDateRange = (value) => {
        let details = this.state.filterDetails

        if (!value) {
            details.startDate = '';
            details.endDate = '';
            this.setState({ filterDetails: details, dateRange: null }, () => {
                if (this.state.dateTimeout) {
                    clearTimeout(this.state.dateTimeout);
                }
                const timeout = setTimeout(() => {
                    this.submittedForms();
                }, 1000);
                this.setState({ dateTimeout: timeout });
            });
            return;
        }

        if (value[0]) {
            details.startDate = value[0];
        } else {
            details.startDate = '';
        }

        if (value[1]) {
            details.endDate = value[1];
        } else {
            details.endDate = '';
        }

        this.setState({ filterDetails: details, dateRange: value }, () => {
            if (this.state.filterDetails.startDate && this.state.filterDetails.endDate) {
                if (this.state.dateTimeout) {
                    clearTimeout(this.state.dateTimeout);
                }
                const timeout = setTimeout(() => {
                    this.submittedForms();
                }, 1000);
                this.setState({ dateTimeout: timeout });
            }
        });
    }

    resetFilter = () => {
        let details = this.state.filterDetails
        details.search = '';
        details.startDate = '';
        details.endDate = '';
        details.formType = 'timesheet_expense';
        details.timesheetExpense = 1;
        details.isFormApproved = 0;

        this.setState({ filterDetails: details, dateRange: null }, () => {
            this.submittedForms()
        });
    }

    onPageChange = (event) => {
        let details = this.state.filterDetails
        details.start = event.first;
        details.length = event.rows;
        this.setState({ filterDetails: details }, () => {
            this.submittedForms();
        })
    };

    onSortChange = (event) => {
        const filterDetails = { ...this.state.filterDetails };
        filterDetails.sortField = event.sortField;
        filterDetails.sortOrder = event.sortOrder === 1 ? 'asc' : 'desc';
        this.setState({ filterDetails }, () => {
            this.submittedForms();
        });
    };

    // actionBodyTemplate = (rowData) => {
    //     return (
    //         <div className="flex gap-2 justify-center">
    //             <Button
    //                 icon="pi pi-eye"
    //                 className="p-button-rounded p-button-text p-button-sm"
    //                 style={{ width: '2rem', height: '2rem', padding: 0 }}
    //                 onClick={() => this.handlePreviewPDF(rowData)}
    //                 tooltip="Preview PDF"
    //                 tooltipOptions={{ position: 'top' }}
    //             />
    //             <Button
    //                 icon="pi pi-download"
    //                 className="p-button-rounded p-button-text p-button-sm"
    //                 style={{ width: '2rem', height: '2rem', padding: 0 }}
    //                 onClick={() => this.handleDownloadPDF(rowData)}
    //                 tooltip="Download PDF"
    //                 tooltipOptions={{ position: 'top' }}
    //             />
    //         </div>
    //     );
    // };

    actionBodyTemplate = (rowData) => {
        const isDownloading = this.state.downloadingIds.includes(rowData.id);

        return (
            <div className="flex gap-2 justify-center items-center">
                {
                    rowData.uploadcount > 0 ? (
                        <Button
                            icon="pi pi-paperclip"
                            className="p-button-rounded p-button-text p-button-sm"
                            style={{ width: '2rem', height: '2rem', padding: 0 }}
                            onClick={() => this.handleViewUploadedFiles(rowData)}
                            tooltip={`Uploaded Documents (${rowData.uploadcount})`}
                            tooltipOptions={{ position: 'top' }}
                        />
                    ) : (
                        // Keeps the eye/download icons aligned across rows
                        <div style={{ width: '2rem' }}></div>
                    )
                }
                <Button
                    icon="pi pi-eye"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handlePreviewPDF(rowData)}
                    tooltip="Preview PDF"
                    tooltipOptions={{ position: 'top' }}
                />
                {
                    isDownloading ? (
                        <div style={{ width: '2rem' }}>
                            <ProgressSpinner style={{ width: '60%', height: '60%' }} strokeWidth="4" />
                        </div>
                    ) : (
                        <Button
                            icon="pi pi-download"
                            className="p-button-rounded p-button-text p-button-sm"
                            style={{ width: '2rem', height: '2rem', padding: 0 }}
                            onClick={() => this.handleDownloadPDF(rowData)}
                            tooltip="Download PDF"
                            tooltipOptions={{ position: 'top' }}
                        />
                    )
                }
            </div>
        );
    };

    handleViewUploadedFiles = async (rowData) => {
        this.revokeFileBlobUrls();
        this.setState({
            showFilesDialog: true,
            isFilesLoading: true,
            uploadedFiles: [],
            currentFileIndex: 0,
            fileBlobUrls: {},
            filesDialogTitle: `Uploaded Documents - ${rowData.name}`
        });
        document.addEventListener('keydown', this.handleViewerKeyDown);

        try {
            // getUploadedFiles route is protected by webAuthMiddleware, which only accepts the WebToken
            const response = await fetch(`${APIURL}${GetUploadedFiles}/${rowData.approvalId}`, {
                headers: {
                    'Authorization': `Bearer ${WebToken}`
                }
            });
            const data = await response.json();
            if (response.ok && data.success === 1) {
                this.setState({ uploadedFiles: data.data || [] }, () => this.showFileAt(0));
            } else {
                this.swalServices.Error(data.msg || 'Failed to load uploaded documents');
            }
        } catch (err) {
            console.error('Error loading uploaded files', err);
            this.swalServices.Error('Failed to load uploaded documents');
        } finally {
            this.setState({ isFilesLoading: false });
        }
    };

    closeFilesDialog = () => {
        document.removeEventListener('keydown', this.handleViewerKeyDown);
        this.revokeFileBlobUrls();
        this.setState({ showFilesDialog: false, uploadedFiles: [], fileBlobUrls: {}, currentFileIndex: 0 });
    };

    revokeFileBlobUrls = () => {
        Object.values(this.state.fileBlobUrls).forEach(url => {
            if (url && url !== 'error') URL.revokeObjectURL(url);
        });
    };

    // Uploaded files may be in protected folders, so fetch with the auth token instead of linking directly
    loadFileBlob = async (file) => {
        if (!file || this.state.fileBlobUrls[file.path] || this.loadingFilePaths.has(file.path)) return;
        this.loadingFilePaths.add(file.path);
        const loginUser = getAuthProps();
        const token = loginUser.token;

        let blobUrl = 'error';
        try {
            const response = await fetch(file.path, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (response.ok === true) {
                const blob = await response.blob();
                blobUrl = URL.createObjectURL(blob);
            }
        } catch (err) {
            console.error('Error loading file', err);
        } finally {
            this.loadingFilePaths.delete(file.path);
        }

        // Dialog may have been closed or switched to another form while loading
        if (!this.state.uploadedFiles.some(f => f.path === file.path)) {
            if (blobUrl !== 'error') URL.revokeObjectURL(blobUrl);
            return;
        }
        this.setState(prevState => ({
            fileBlobUrls: { ...prevState.fileBlobUrls, [file.path]: blobUrl }
        }));
    };

    showFileAt = (index) => {
        const files = this.state.uploadedFiles;
        if (index < 0 || index >= files.length) return;
        this.setState({ currentFileIndex: index });
        this.loadFileBlob(files[index]);
        // Preload neighbours so arrow navigation feels instant
        this.loadFileBlob(files[index + 1]);
        this.loadFileBlob(files[index - 1]);
    };

    handleViewerKeyDown = (e) => {
        if (!this.state.showFilesDialog) return;
        if (e.key === 'ArrowLeft') this.showFileAt(this.state.currentFileIndex - 1);
        if (e.key === 'ArrowRight') this.showFileAt(this.state.currentFileIndex + 1);
    };

    downloadCurrentFile = () => {
        const file = this.state.uploadedFiles[this.state.currentFileIndex];
        const blobUrl = file && this.state.fileBlobUrls[file.path];
        if (!blobUrl || blobUrl === 'error') return;
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = file.filename || 'document';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    getFileType = (filePath) => {
        const path = (filePath || '').toLowerCase();
        if (path.endsWith('.pdf')) return 'pdf';
        if (/\.(jpg|jpeg|png|gif|bmp|webp)$/.test(path)) return 'image';
        if (/\.(doc|docx)$/.test(path)) return 'word';
        return 'other';
    };

    getFileIcon = (filePath) => {
        const type = this.getFileType(filePath);
        if (type === 'pdf') return 'pi pi-file-pdf text-red-600';
        if (type === 'word') return 'pi pi-file-word text-blue-600';
        if (type === 'image') return 'pi pi-image text-green-600';
        return 'pi pi-file text-gray-600';
    };

    renderFileViewer = () => {
        const { uploadedFiles, currentFileIndex, fileBlobUrls } = this.state;
        const file = uploadedFiles[currentFileIndex];
        const blobUrl = fileBlobUrls[file.path];
        const type = this.getFileType(file.path);
        const total = uploadedFiles.length;

        let content;
        if (!blobUrl) {
            content = <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />;
        } else if (blobUrl === 'error') {
            content = <p className="text-gray-500 m-0">Unable to load this document.</p>;
        } else if (type === 'image') {
            content = <img src={blobUrl} alt={`Document ${currentFileIndex + 1}`} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />;
        } else if (type === 'pdf') {
            // Hide the browser PDF viewer's toolbar & thumbnail panel so only the document is shown
            content = <iframe key={blobUrl} src={`${blobUrl}#toolbar=0&navpanes=0&view=FitH`} title={`Document ${currentFileIndex + 1}`} className="w-full h-full border-0" />;
        } else {
            content = (
                <div className="flex flex-col items-center gap-3 text-gray-600">
                    <i className={this.getFileIcon(file.path)} style={{ fontSize: '4rem' }}></i>
                    <p className="m-0">Preview is not available for this file type.</p>
                    <Button label="Download" icon="pi pi-download" onClick={this.downloadCurrentFile} />
                </div>
            );
        }

        const navButtonStyle = { width: '2.5rem', height: '2.5rem', flexShrink: 0 };

        return (
            <div className="flex flex-col gap-3">
                <div className="flex items-center justify-between">
                    <span className="text-gray-700 font-medium">
                        Document {currentFileIndex + 1} of {total} ({(file.filename || '').split('.').pop().toUpperCase()})
                    </span>
                    <Button
                        icon="pi pi-download"
                        className="p-button-rounded p-button-text p-button-sm"
                        style={{ width: '2rem', height: '2rem', padding: 0 }}
                        onClick={this.downloadCurrentFile}
                        disabled={!blobUrl || blobUrl === 'error'}
                        tooltip="Download"
                        tooltipOptions={{ position: 'top' }}
                    />
                </div>
                <div className="flex items-center gap-2">
                    <Button
                        icon="pi pi-chevron-left"
                        className="p-button-rounded p-button-outlined"
                        style={{ ...navButtonStyle, visibility: total > 1 ? 'visible' : 'hidden' }}
                        onClick={() => this.showFileAt(currentFileIndex - 1)}
                        disabled={currentFileIndex === 0}
                    />
                    <div className="flex-1 flex items-center justify-center bg-gray-100 rounded overflow-hidden" style={{ height: '65vh' }}>
                        {content}
                    </div>
                    <Button
                        icon="pi pi-chevron-right"
                        className="p-button-rounded p-button-outlined"
                        style={{ ...navButtonStyle, visibility: total > 1 ? 'visible' : 'hidden' }}
                        onClick={() => this.showFileAt(currentFileIndex + 1)}
                        disabled={currentFileIndex === total - 1}
                    />
                </div>
                {total > 1 && (
                    <div className="flex justify-center gap-2 flex-wrap">
                        {uploadedFiles.map((f, index) => (
                            <button
                                key={index}
                                type="button"
                                onClick={() => this.showFileAt(index)}
                                title={`Document ${index + 1}`}
                                className={`flex items-center justify-center w-10 h-10 rounded bg-white cursor-pointer border-2 ${index === currentFileIndex ? 'border-blue-600' : 'border-gray-200'}`}
                            >
                                <i className={this.getFileIcon(f.path)} style={{ fontSize: '1.1rem' }}></i>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    };


    handlePreviewPDF = async (rowData) => {
        const formId = rowData.id;
        const loginUser = getAuthProps();
        const token = loginUser.token;

        let url = "";
        if (rowData.isdynamic) {
            url = `${APIURL}${GetDynamicFormPreview}/${formId}/0`;

        } else {
            url = `${APIURL}${GetSubmittedFormPreview}/${formId}/0`;
        }

        try {
            const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok === true) {
                const blob = await response.blob();
                const fileURL = URL.createObjectURL(blob);
                window.open(fileURL, '_blank');
            } else {
                this.swalServices.Error('File not found')
            }
        } catch (err) {
            console.error('Error opening PDF', err);
        }
    };

    // handleDownloadPDF = async (rowData) => {
    //     const formId = rowData.id;
    //     const loginUser = getAuthProps();
    //     const token = loginUser.token;

    //     let url = "";
    //     if (rowData.isdynamic) {
    //         url = `${APIURL}${GetDynamicFormPreview}/${formId}`;

    //     } else {
    //         url = `${APIURL}${GetSubmittedFormPreview}/${formId}/1`;
    //     }

    //     try {
    //         const response = await fetch(url, {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`
    //             }
    //         });

    //         if (response.ok === true) {
    //             const blob = await response.blob();
    //             const downloadUrl = URL.createObjectURL(blob);

    //             const link = document.createElement('a');
    //             link.href = downloadUrl;

    //             let filename = rowData.formname;
    //             link.download = filename
    //             document.body.appendChild(link);
    //             link.click();
    //             document.body.removeChild(link);

    //             URL.revokeObjectURL(downloadUrl);
    //         } else {
    //             this.swalServices.Error('File not found')
    //         }
    //     } catch (err) {
    //         console.error('Download failed', err);
    //     }
    // };
    handleDownloadPDF = async (rowData) => {
        const formId = rowData.id;
        const loginUser = getAuthProps();
        const token = loginUser.token;

        // Add to downloadingIds
        this.setState(prevState => ({
            downloadingIds: [...prevState.downloadingIds, formId]
        }));

        let url = "";
        if (rowData.isdynamic) {
            url = `${APIURL}${GetDynamicFormPreview}/${formId}/1`;
        } else {
            url = `${APIURL}${GetSubmittedFormPreview}/${formId}/1`;
        }

        try {
            const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok === true) {
                const blob = await response.blob();
                const downloadUrl = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = rowData.formname;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                URL.revokeObjectURL(downloadUrl);
            } else {
                this.swalServices.Error('File not found');
            }
        } catch (err) {
            console.error('Download failed', err);
        } finally {
            // Remove from downloadingIds
            this.setState(prevState => ({
                downloadingIds: prevState.downloadingIds.filter(id => id !== formId)
            }));
        }
    };

    columnHeaderMap = {
        srNo: "Sr No",
        formname: "Form Type",
        name: "Candidate Name",
        isapproved: "Status",
        approvalLink: "Approval Link",
        createddate: "Submitted Date",
    };
    exportCSV(selectionOnly) {
        if (this.dt.current) {
            const data = selectionOnly
                ? this.dt.current.props.value.filter(row => this.dt.current.isSelected(row))
                : this.dt.current.props.value;

            const fields = Object.keys(this.columnHeaderMap);

            // Header row
            let csv = fields.map(field => `"${this.columnHeaderMap[field]}"`).join(',') + '\n';

            // Data rows
            data.forEach(rowData => {
                const row = fields.map(field => {
                    if (field === 'approvalLink') {
                        const link = `https://admin.arbourhealthcaregroup.co.uk/approve-form?=${rowData.approvalId || ''}`;
                        return `"=HYPERLINK(""${link}"", ""Check Status"")"`;
                    }
                    else {
                        return `"${rowData[field] !== undefined ? rowData[field] : ''}"`;
                    }
                });
                csv += row.join(',') + '\n';
            });

            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const filename = 'Timesheet_Expense.csv';

            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                const url = URL.createObjectURL(blob);
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }


    getExportColumns() {
        return this.state.submittedFormsList.map((col) => ({ title: 'ABC', dataKey: 'XYZ' }));
    }

    exportPdf() {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                const exportColumns = this.getExportColumns();
                doc.autoTable(exportColumns, this.state.submittedFormsList);
                doc.save('Timesheet & Expense.pdf');
            });
        });
    }

    saveAsExcelFile(buffer, fileName) {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], { type: EXCEL_TYPE });

                module.default.saveAs(data, "Timesheet/Expense" + EXCEL_EXTENSION);
            }
        });
    }

    exportExcel() {
        import('xlsx').then((xlsx) => {

            const fields = Object.keys(this.columnHeaderMap);

            const modifiedData = this.state.submittedFormsList.map(item => {
                const newItem = {};
                fields.forEach(field => {
                    if (field === 'approvalLink') {
                        // Placeholder, we'll replace later
                        newItem[this.columnHeaderMap[field]] = 'Check Status';
                    } else {
                        newItem[this.columnHeaderMap[field]] = item[field] !== undefined ? item[field] : '';
                    }
                });
                return newItem;
            });

            const worksheet = xlsx.utils.json_to_sheet(modifiedData);
            const approvalLinkCol = fields.findIndex(f => f === 'approvalLink'); // 0-based index

            this.state.submittedFormsList.forEach((item, idx) => {
                const approvalLink = `https://admin.arbourhealthcaregroup.co.uk/approve-form?=${item.approvalId || ''}`;
                const cellRef = xlsx.utils.encode_cell({ c: approvalLinkCol, r: idx + 1 }); // +1 because row 0 is header
                worksheet[cellRef].f = `HYPERLINK("${approvalLink}", "Check Status")`;
            });

            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });

            this.saveAsExcelFile(excelBuffer, 'submittedFormsList');
        });
    }

    exportMergedPdf = async () => {
        const list = this.state.submittedFormsList;
        if (!list || list.length === 0) return;

        this.setState({ isMergingPdf: true });
        
        const submissions = list.map(item => ({
            id: item.id,
            isdynamic: item.isdynamic || 0,
            formtype: item.formtype || ''
        }));

        try {
            const response = await this.adminServices.downloadMergedForms(submissions);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Merged_Forms.pdf');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            console.error("Error merging PDFs", error);
        } finally {
            this.setState({ isMergingPdf: false });
        }
    }


    handleSelectChange = (event) => {
        let details = this.state.filterDetails;
        details.timesheetExpense = event.target.value;
        this.setState({ filterDetails: details }, () => {
            this.submittedForms();
        });
    };

    handleApproveChange = (event) => {
        let details = this.state.filterDetails;
        details.isFormApproved = event.target.value;
        this.setState({ filterDetails: details }, () => {
            this.submittedForms();
        });
    };

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }

        const pageSizes = [5, 10, 20, 50, 100];
        let rowsPerPageOptions = pageSizes.filter(size => size < this.state.totalRecords);

        if (!rowsPerPageOptions.includes(this.state.totalRecords)) {
            rowsPerPageOptions.push(this.state.totalRecords);
        }

        const paginatorRight = (
            <React.Fragment>
                <Button label="Export CSV" icon="pi pi-file" className="export-btn" onClick={() => this.exportCSV(false)} />
                <Button label="Merge PDF" icon="pi pi-file-pdf" className="export-btn" onClick={this.exportMergedPdf} loading={this.state.isMergingPdf} />
                <Button label="Export Excel" icon="pi pi-file-excel" className="export-btn" onClick={this.exportExcel} />
            </React.Fragment>
        );

        return (
            <div className='user-lists'
                style={{ height: "calc((100dvh / 0.85) - 60.8px)" }}
            >
                <div className='user-lists-inner h-full p-[30px]'>
                    <div className='title flex items-center justify-between mb-[10px]'>
                        <h1 className='text-[22px] m-0 font-semibold text-[#004AAD]' style={{ lineHeight: "30px" }}>Timesheet & Expense</h1>
                    </div>
                    <div className='user-table p-5 bg-white rounded-[16px]' style={{ border: "1px solid #DFDFDF" }}>
                        <div className='table-inner grid grid-cols-5 gap-5 items-end'>
                            <div className="input-grp !mb-0">
                                <label>
                                    Search
                                </label>
                                <InputText
                                    type="search"
                                    value={this.state.globalFilter}
                                    onChange={(e) => this.handleSearch(e.target.value)}
                                    placeholder="Search across all columns..."
                                />
                            </div>
                            <div className="input-grp !mb-0 col-span-2">
                                <label>
                                    Filter by Date Range
                                </label>
                                <Calendar
                                    value={this.state.dateRange}
                                    onChange={(e) => this.handleChangeDateRange(e.value)}
                                    selectionMode="range"
                                    placeholder="Select date & time range"
                                    dateFormat="yy-mm-dd"
                                    showTime
                                    hourFormat="24"
                                    stepMinute={10}
                                    numberOfMonths={2}
                                    maxDate={new Date()}
                                    style={{ height: "42px" }}
                                />
                            </div>
                            <div className='input-grp !mb-0'>
                                <label>Form Type:</label>
                                <select value={this.state.filterDetails.timesheetExpense} onChange={this.handleSelectChange}>
                                    <option key={1} value={1}>Timesheet</option>
                                    <option key={2} value={2}>Expense</option>
                                </select>
                            </div>
                            <div className='input-grp !mb-0'>
                                <label>Status:</label>
                                <select value={this.state.filterDetails.isFormApproved} onChange={this.handleApproveChange}>
                                    <option key={1} value={0}>-- Select --</option>
                                    <option key={2} value={1}>Approved</option>
                                    <option key={3} value={2}>Not Approved</option>
                                </select>
                            </div>
                            <Button
                                label="Reset filters"
                                className='w-fit h-fit'
                                onClick={() => this.resetFilter()}
                                style={{ fontWeight: "400", lineHeight: "1" }}
                            />
                        </div>
                        <div className='sub-table rounded-xl shadow-sm overflow-hidden border border-gray-200 bg-white mt-[30px]'>
                            <DataTable
                                value={this.state.submittedFormsList}
                                paginator
                                lazy
                                first={this.state.filterDetails.start}
                                rows={(this.state.totalRecords > this.state.filterDetails.length) ? this.state.filterDetails.length : this.state.totalRecords}
                                totalRecords={this.state.totalRecords}
                                onPage={(e) => this.onPageChange(e)}
                                rowsPerPageOptions={rowsPerPageOptions}
                                responsiveLayout="scroll"
                                scrollable
                                scrollHeight="calc((100dvh / 0.85) - 360px)"
                                className="min-w-full"
                                emptyMessage="No data found"
                                loading={this.state.isLoading}
                                loadingIcon={
                                    <div className="flex justify-center items-center w-full py-4">
                                        <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
                                    </div>
                                }
                                onSort={(e) => this.onSortChange(e)}
                                sortField={this.state.filterDetails.sortField}
                                sortOrder={this.state.filterDetails.sortOrder === 'asc' ? 1 : -1}
                                paginatorRight={paginatorRight}
                                ref={this.dt}
                            >
                                <Column
                                    field="srNo"
                                    header="Sr No"
                                    body={(rowData, options) => options.rowIndex + 1}
                                    filterPlaceholder="Search by ID"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="formname"
                                    header="Form Type"
                                    sortable
                                    filterPlaceholder="Search by form"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="name"
                                    header="Candidate Name"
                                    sortable
                                    filterPlaceholder="Search by name"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="isapproved"
                                    header="Status"
                                    sortable
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                    body={(rowData) => (
                                        <div className="flex items-center gap-2">
                                            {rowData.isapproved == 1 ? (
                                                <>
                                                    <a href={`approve-form?=${rowData.approvalId}`}>
                                                        <img
                                                            src="/approved.png"
                                                            height={25}
                                                            width={25}
                                                            alt="Approve"
                                                            title="Check Approval"
                                                        />
                                                    </a>
                                                </>
                                            ) : (
                                                <>
                                                    <a href={`approve-form?=${rowData.approvalId}`}>
                                                        <img
                                                            src="/notapproved.png"
                                                            height={25}
                                                            width={25}
                                                            alt="Approve"
                                                            title="Approve Now"
                                                        />
                                                    </a>
                                                </>
                                            )}
                                        </div>
                                    )}
                                />
                                <Column
                                    field="createddate"
                                    header="Submitted Date"
                                    sortable
                                    filterPlaceholder="Search by createddate"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    header="Actions"
                                    body={this.actionBodyTemplate}
                                    style={{ textAlign: 'center', width: '10rem' }}
                                    headerClassName="bg-blue-50 text-blue-800 font-medium centered-header"
                                />
                            </DataTable>
                        </div>
                    </div>
                </div>
                <Dialog
                    header={this.state.filesDialogTitle}
                    visible={this.state.showFilesDialog}
                    style={{ width: '70rem', maxWidth: '95vw' }}
                    onHide={this.closeFilesDialog}
                    draggable={false}
                >
                    {this.state.isFilesLoading ? (
                        <div className="flex justify-center items-center w-full py-4">
                            <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
                        </div>
                    ) : this.state.uploadedFiles.length === 0 ? (
                        <p className="text-center text-gray-500 py-4 m-0">No documents uploaded for this form.</p>
                    ) : (
                        this.renderFileViewer()
                    )}
                </Dialog>
            </div>
        )
    }
}